import React from "react";
import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../../Icons/CreateIcon";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/Endpoint";
const CreateNoticeComponent = loadable(
  () => import("../../components/Notices/CreateNotice")
);
const CreateNotice = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["notice"],
  });
  const handleCreate = async (values: any, setError: any) => {
    let formData = {
      ...values,
      branch: values?.branch
        ? values?.branch?.map((item: any) => item.value)
        : [],
      user: values?.user ? values?.user?.map((item: any) => item.value) : [],
      staff: values?.staff ? values?.staff?.map((item: any) => item.value) : [],
    };
    console.log(formData);
    const url = `${APIS.NOTICE}`;
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Notice
        </span>
      </div>
      <CreateNoticeComponent
        handleCreate={handleCreate}
        isPostLoading={isPostLoading}
      />
    </>
  );
};

export default CreateNotice;
